//@flow
import env from '../../../environment';
import {getCreator, putCreator} from '../../../http';

export const endpoints = Object.freeze({
  FETCH_CONTACT_SUMMARY: `${env.baseApiUrl}/winehouse/admin/crm/contact/summary`,
  UPDATE_CONTACT_NAME: `${env.baseApiUrl}/winehouse/admin/crm/contact/name`,
  EXPORT_CONTACT_SUMMARY: `${env.baseApiUrl}/winehouse/admin/crm/contact/summary/export`,
});

export type ContactSummarySearchParamsFilters = {
  created_from?: string,
  created_to?: string,
  last_message_date?: string,
  channel?: string,
  tags?: string,
  status?: string,
  page?: number,
  size?: number,
  name?: string,
};

export const fetchContactSummaryApi = getCreator(
  endpoints.FETCH_CONTACT_SUMMARY
);

export const updateContactNameApi = putCreator(endpoints.UPDATE_CONTACT_NAME);
